import { render, staticRenderFns } from "./NoSubscribers.vue?vue&type=template&id=cf5646dc&scoped=true&"
var script = {}
import style0 from "./NoSubscribers.vue?vue&type=style&index=0&id=cf5646dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5646dc",
  null
  
)

export default component.exports